"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DanalIdentificationConfirmResponseData = exports.DanalIdentificationPrepareResponseData = exports.CommonIdentificationResponseData = exports.DanalIdentificationRequestQueries = exports.IdentificationOpenType = void 0;
var IdentificationOpenType;
(function (IdentificationOpenType) {
    IdentificationOpenType["Iframe"] = "IFRAME";
    IdentificationOpenType["Popup"] = "POPUP";
})(IdentificationOpenType = exports.IdentificationOpenType || (exports.IdentificationOpenType = {}));
class DanalIdentificationRequestQueries {
}
exports.DanalIdentificationRequestQueries = DanalIdentificationRequestQueries;
class CommonIdentificationResponseData {
}
exports.CommonIdentificationResponseData = CommonIdentificationResponseData;
class DanalIdentificationPrepareResponseData {
}
exports.DanalIdentificationPrepareResponseData = DanalIdentificationPrepareResponseData;
class DanalIdentificationConfirmResponseData extends DanalIdentificationPrepareResponseData {
}
exports.DanalIdentificationConfirmResponseData = DanalIdentificationConfirmResponseData;
//# sourceMappingURL=identification.js.map